module.exports = function() {
  return new Worker(__webpack_public_path__ + "b81d0f2201962a4f32c2.worker.js");
};